import { useSnackbar } from '@bos/snackbar';
import type { NavigateOptions } from '@tanstack/react-router';

export const useAppSnackbar = () => {
	return useSnackbar<NavigateOptions>();
};
